import { render, staticRenderFns } from "./addVehicleInspectionReport.vue?vue&type=template&id=6c20fce9"
import script from "./addVehicleInspectionReport.vue?vue&type=script&lang=js"
export * from "./addVehicleInspectionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports